import type { FC } from "react";
import { getIntegrationNameBySlug } from "./integrationConfigs.js";

/**
 * Breadcrumb label for a single integration's detail page. The name comes from
 * the static registry rather than a fetch, so this resolves synchronously and
 * settles on a generic label for a slug the registry doesn't know.
 */
export const IntegrationNameCrumbLabel: FC<{
  integrationSlug: string | undefined;
}> = ({ integrationSlug }) => (
  <>{getIntegrationNameBySlug(integrationSlug) ?? "Integration"}</>
);
